<template>
  <div class="main-container">
    <navbar/>
    <app-main/>
    <foot/>
  </div>
</template>

<script>
import {AppMain, Foot, Navbar} from "./components";
import {mapState} from "vuex";

export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    Foot
  },
  computed: {
    ...mapState({}),
  },
  created() {
    // this.sidebar.opened = this.layout.sidebar;
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.main-container {
  background: url("/static/user/img/app/bg.jpg") no-repeat center;
  background-size: cover;
  height: 100vh;
  width: 100vw;
  position: relative;
  min-height: 800px;
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/user/layout/index.vue